import { z } from 'zod';
import { vtexEnvironmentSchema } from '../domain/enums';

export const createTenantRequestSchema = z.object({
  name: z.string().min(2).max(120),
  /** `accountName` da conta VTEX, ex.: "minhaloja". */
  accountName: z
    .string()
    .min(2)
    .max(60)
    .regex(/^[a-z0-9-]+$/, 'accountName deve conter apenas minúsculas, números e hífen'),
  environment: vtexEnvironmentSchema.default('vtexcommercestable'),
  appKey: z.string().min(10).max(200),
  appToken: z.string().min(10).max(500),
  /** Sandbox libera operações de spike que ficam bloqueadas em produção. */
  isSandbox: z.boolean().default(false),
});
export type CreateTenantRequest = z.infer<typeof createTenantRequestSchema>;

export const updateTenantRequestSchema = createTenantRequestSchema
  .partial()
  .extend({ isActive: z.boolean().optional() });
export type UpdateTenantRequest = z.infer<typeof updateTenantRequestSchema>;

export interface TenantSummary {
  id: string;
  name: string;
  accountName: string;
  environment: string;
  isSandbox: boolean;
  isActive: boolean;
  hasCredentials: boolean;
  productCount: number;
  lastIngestionAt: string | null;
  lastAuditAt: string | null;
  averageScore: number | null;
  createdAt: string;
}

export interface ConnectionTestResult {
  ok: boolean;
  message: string;
  /** Amostra de productIds retornada pela conta, para provar a conexão. */
  sampleProductIds: number[];
  latencyMs: number;
}

export const styleGuideSchema = z.object({
  language: z.string().min(2).max(10).default('pt-BR'),
  toneOfVoice: z.string().max(2000).default(''),
  requiredTerms: z.array(z.string().min(1).max(80)).default([]),
  forbiddenTerms: z.array(z.string().min(1).max(80)).default([]),
  /** Instruções livres anexadas ao prompt, sempre subordinadas aos validadores. */
  extraInstructions: z.string().max(4000).default(''),
});
export type StyleGuide = z.infer<typeof styleGuideSchema>;

export const DEFAULT_STYLE_GUIDE: StyleGuide = {
  language: 'pt-BR',
  toneOfVoice: 'Claro, objetivo e informativo. Sem superlativos vazios.',
  requiredTerms: [],
  forbiddenTerms: [],
  extraInstructions: '',
};
